/* ==========================================================================
   BONPEK BABY — PHONE FILTER DRAWER SCROLLING                  25 Sep 2026
   --------------------------------------------------------------------------
   Loaded (deferred) from snippets/bonpek-grid-enhancements.liquid.

   🔴 THE PROBLEM THIS SOLVES - DO NOT DELETE THIS FILE.
   When the phone filter drawer opens, Expanse calls lockMobileScrolling()
   (assets/a11y.js), which puts .lock-scroll on <html>. The page can no
   longer be scrolled by finger. The stock drawer held four short boxes and
   fitted on one screen, so the theme never needed the drawer itself to
   scroll - it is NOT a scroll container.

   Our grouped sidebar is roughly 2,000px tall. With the page locked and the
   drawer not scrollable, every group below "Milk" was unreachable on a
   phone: no finger scroll, no wheel, nothing. Reported by Narek, 25 Sep:
   "now the age is on top but I'm not able to scroll down the filter side
   tab". Keyboard focus still moved the view (a programmatic scroll ignores
   .lock-scroll), which is exactly why it looked fine in testing until the
   drawer was actually dragged with a finger.

   🔴 WHY max-height IS MEASURED IN JS RATHER THAN SET IN CSS.
   The drawer sits in normal page flow, so where its top edge lands depends
   on how far the page happened to be scrolled when Filter was tapped - it
   can be 110px down the screen or 340px down. A fixed calc(100dvh - Npx)
   is right in one case and leaves content below the fold in the other,
   which is the original bug again. So we measure the panel's own top and
   give it exactly the space that is left.

   visualViewport is preferred over innerHeight because on iOS the URL bar
   shrinks the visible area without changing innerHeight.

   No event names are hard-coded: the theme's open/close is observed through
   the .is-active class with a MutationObserver, so a theme update that
   renames EVENTS.toggleMobileFilters cannot silently break this.
   ========================================================================== */
(function () {
  'use strict'

  var MOBILE = '(max-width: 768px)'
  var MIN_HEIGHT = 220 // never squash the drawer to nothing
  var BOTTOM_GAP = 8 // breathing room above the viewport edge

  var rafId = 0
  var settleId = 0

  function host() {
    return document.querySelector('collection-mobile-filters')
  }

  function panel() {
    var h = host()
    return h ? h.querySelector('.filter-wrapper') : null
  }

  function viewportHeight() {
    return window.visualViewport ? window.visualViewport.height : window.innerHeight
  }

  function fit() {
    var p = panel()
    if (!p) return

    // Closed, or we are on desktop where the sidebar is used instead:
    // hand the element back to the stylesheet untouched.
    if (!p.classList.contains('is-active') || !window.matchMedia(MOBILE).matches) {
      p.style.removeProperty('max-height')
      p.style.removeProperty('overflow-y')
      return
    }

    var top = p.getBoundingClientRect().top
    var space = viewportHeight() - top - BOTTOM_GAP
    if (space < MIN_HEIGHT) space = MIN_HEIGHT

    p.style.maxHeight = Math.round(space) + 'px'
    p.style.overflowY = 'auto'
  }

  /* Coalesce bursts: the observer fires for every class change inside the
     drawer (each checkbox, each <details> toggle). One frame now for the
     immediate case, one late pass after the open transition has settled. */
  function schedule() {
    if (rafId) cancelAnimationFrame(rafId)
    rafId = requestAnimationFrame(function () {
      rafId = 0
      fit()
    })
    clearTimeout(settleId)
    settleId = setTimeout(fit, 400)
  }

  function watch() {
    var h = host()
    if (!h) return false

    new MutationObserver(schedule).observe(h, {
      attributes: true,
      attributeFilter: ['class'],
      subtree: true,
      childList: true
    })

    schedule()
    return true
  }

  function boot() {
    if (watch()) return
    /* <collection-mobile-filters> is inside an <is-land on:visible> island,
       so it can be defined well after DOMContentLoaded. Poll briefly, then
       give up rather than leave a timer running forever. */
    var tries = 0
    var timer = setInterval(function () {
      if (watch() || ++tries > 40) clearInterval(timer)
    }, 150)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot)
  } else {
    boot()
  }

  window.addEventListener('resize', schedule)
  window.addEventListener('orientationchange', schedule)
  if (window.visualViewport) window.visualViewport.addEventListener('resize', schedule)

  /* The page is meant to be frozen while the drawer is open, but a sticky
     header collapsing, an address bar retracting or a programmatic scroll
     can still move the panel's top edge. Re-measuring on scroll costs a
     rect read inside an already-coalesced frame and keeps the drawer from
     ending short of the viewport bottom. */
  window.addEventListener('scroll', schedule, { passive: true })
})()
